import { render, staticRenderFns } from "./ReCardKBPost.vue?vue&type=template&id=f37a81f8&scoped=true"
import script from "./ReCardKBPost.vue?vue&type=script&lang=js"
export * from "./ReCardKBPost.vue?vue&type=script&lang=js"
import style0 from "./ReCardKBPost.vue?vue&type=style&index=0&id=f37a81f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37a81f8",
  null
  
)

export default component.exports